// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { 
  getAuth, 
  GoogleAuthProvider, 
} from "firebase/auth";
import { getFirestore, doc, getDoc, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";  
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { setPersistence, browserLocalPersistence, connectAuthEmulator } from "firebase/auth";
import { initializeAuth, indexedDBLocalPersistence, inMemoryPersistence } from "firebase/auth";

import { Capacitor } from "@capacitor/core";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// ❌ DO NOT initialize analytics automatically
// const analytics = getAnalytics(app);

// ✅ Instead: lazy init after consent
let analyticsInstance = null;

export const initAnalytics = async () => {
  try {
    if (typeof window === "undefined") return null; // SSR safety
    if (!firebaseConfig.measurementId) {
      console.warn("No measurementId set – Analytics will not be initialized.");
      return null;
    }

    const supported = await isSupported();
    if (!supported) {
      console.warn("Analytics not supported in this environment.");
      return null;
    }

    if (!analyticsInstance) {
      analyticsInstance = getAnalytics(app);
      console.log("✅ Firebase Analytics initialized");
    }

    return analyticsInstance;
  } catch (err) {
    console.error("Error initializing Firebase Analytics:", err);
    return null;
  }
};

// Initialize Firebase Authentication
const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, {
      // This is the key change for iOS WKWebView
      persistence: indexedDBLocalPersistence,

      // If you STILL get weird behavior, temporarily switch to this
      // to confirm the issue is persistence/storage:
      // persistence: inMemoryPersistence,
    })
  : getAuth(app);

const googleProvider = new GoogleAuthProvider();


if (!Capacitor.isNativePlatform()) {
  setPersistence(auth, browserLocalPersistence)
    .then(() => console.log("✅ Auth persistence set (web)"))
    .catch((e) => console.error("❌ Auth persistence error (web):", e));
} else {
  console.log("📱 Native platform: using initializeAuth persistence");
}

console.log("🔥 Firebase Auth config:", auth.config);

// Initialize Firestore
const db = getFirestore(app);
const functions = getFunctions(app); //Initialize Functions
const storage = getStorage(app);

console.log("Auth connected to emulator?", auth._canInitEmulator);

// Connect to emulators in development - automatically set to development when running npm start
// if (process.env.NODE_ENV === 'development') {
//   try {
//     connectAuthEmulator(auth, 'http://localhost:9099');
//     connectFirestoreEmulator(db, 'localhost', 8080); //Firestore Emulator
//     connectFunctionsEmulator(functions, 'localhost', 5001);
//     connectStorageEmulator(storage, 'localhost', 9199);
//     console.log('Connected to Firebase emulators');
//   } catch (error) {
//     console.log('Emulators already connected or not available');
//   }
// }

export { 
  auth, 
  googleProvider, 
  db,
  functions,
  storage,
  analyticsInstance as analytics // optional export if you need it
};